<form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="modal-body">
    <div class="row">
      <!-- Category/Subcategory Name -->
      <div class="col-sm-12">
        <div class="form-group">
          <label for="name">
            {{ isSubCategory ? 'Sub Category Name' : 'Category Name' }}
          </label>
          <input formControlName="name" type="text" id="name" class="form-control" [placeholder]="
              isSubCategory
                ? 'Enter sub category name'
                : 'Enter category name'
            " />
          <div *ngIf="f.name.touched && f.name.invalid" class="text-danger">
            <div *ngIf="f.name.errors?.required">Name is required</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Is Enabled -->
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Is Enabled</label>
          <mat-checkbox formControlName="isActive" [dir]="langDir" color="primary">
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button type="submit" class="btn btn-success btn-sm" [disabled]="categoryForm.invalid">
      <i class="las la-save"></i>
      {{ isEdit ? 'Update' : 'Save' }}
    </button>
    <button type="button" class="btn btn-danger btn-sm" (click)="onCancel()">
      <i class="las la-times-circle"></i> Cancel
    </button>
  </div>
</form>